module.exports = __webpack_public_path__ + "static/media/feature-case-management.346a53ca.png";